"use client";
import React from "react";
import PropTypes from "prop-types";

// local component imports
import VideoTrail from "./VideoTrail";

/**
 * VideoWidget renders a video trail carousel for a widget's video stories.
 * @param {object} props - Component props
 * @param {object} props.widget - Widget configuration object
 * @returns {React.ReactElement} The rendered video widget
 */
const VideoWidget = ({ widget, isMobile }) => {
  const videos = Array.isArray(widget?.typeConfig?.stories) ? widget.typeConfig.stories : [];
  const sectionPadding = {
    paddingLeft: `${widget?.sectionSettings?.padding?.left || 0}px`,
    paddingRight: `${widget?.sectionSettings?.padding?.right || 0}px`,
  };

  if (videos.length === 0) {
    return null;
  }

  return (
    <div className="w-full" id={`video-widget-${videos[0]?.id}`}>
      <VideoTrail videos={videos} sectionPadding={sectionPadding} isMobile={isMobile} />
    </div>
  );
};

VideoWidget.propTypes = {
  widget: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
};
export default VideoWidget;
